import { Switch } from 'react-router-dom'
import RouteMiddleware from 'src/components/common/RouteMiddleware'
import { makeStyles } from '@material-ui/core/styles'
import MotorInsuranceDetails from 'src/components/BuyPolicy/insuranceScreens/motor/MotorInsuranceDetails'
import MotorInsuranceMemberDetails from 'src/components/BuyPolicy/insuranceScreens/motor/MotorInsuranceMemberDetails'
import TermsAndConditionsMotor from 'src/components/BuyPolicy/insuranceScreens/motor/TermsAndConditionMotor'
import ViewPlanDetailsMotor from 'src/components/BuyPolicy/insuranceScreens/motor/ViewPlanDetailsMotor'

const MotorInsuranceDetailsLayout = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.insuranceDetailsContainer}>
        <Switch>
          <RouteMiddleware
            title={'Member Details Form'}
            path='/individual/dashboard/buyPolicy/motor/insuranceDetails/member-details'
            exact
            component={MotorInsuranceMemberDetails}
          />
          <RouteMiddleware
            title={'Terms And Conditions'}
            path='/individual/dashboard/buyPolicy/motor/insuranceDetails/terms-and-conditions'
            component={TermsAndConditionsMotor}
          />
          <RouteMiddleware
            title={'Terms And Conditions'}
            path='/individual/dashboard/buyPolicy/motor/insuranceDetails/plan-details'
            component={ViewPlanDetailsMotor}
          />
          <RouteMiddleware
            title={'Insurance Details'}
            path='/'
            component={MotorInsuranceDetails}
          />
        </Switch>
      </div>
    </>
  )
}

export default MotorInsuranceDetailsLayout

const useStyles = makeStyles({
  insuranceDetailsContainer: {
    width: '100%',
  },
})
